import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '../../../../../_gori/constants'

interface NavigationControlsProps {
  onManualCapture: () => void
  isCapturing: boolean
  hash: string | undefined
}

interface ErrorFallbackProps {
  errorMessageKey: string
  hash: string | undefined
}

export function ErrorFallback({errorMessageKey, hash}: ErrorFallbackProps) {
  const intl = useIntl()
  const navigate = useNavigate()

  return (
    <div className='gori-signature-take-photo d-flex flex-column align-items-center justify-content-center p-4'>
      <div className='text-center'>
        <p className='fs-5 text-danger mb-4'>{intl.formatMessage({id: errorMessageKey})}</p>
        <span
          className='gori-signature-tutorial__inline-link text-decoration-underline cursor-pointer'
          onClick={() =>
            navigate(ROUTES.GORI_SIGNATURE.METHOD_SELECT, {
              state: {hash: hash},
            })
          }
        >
          {intl.formatMessage({id: 'GORI_SIGNATURE_TRY_DIFFERENT_METHOD'})}
        </span>
      </div>
    </div>
  )
}
ErrorFallback.displayName = 'ErrorFallback'

export function NavigationControls({onManualCapture, isCapturing, hash}: NavigationControlsProps) {
  const intl = useIntl()
  const navigate = useNavigate()

  return (
    <>
      <div className='text-center mb-5'>
        <img
          src='/media/gori/gori-signature/gori-signature-black.svg'
          alt={intl.formatMessage({id: 'GORI_SIGNATURE_TITLE'})}
          className='gori-signature-logo mb-4'
        />
        <p className='fs-5 text-dark'>
          {intl.formatMessage({id: 'GORI_SIGNATURE_TAKE_PHOTO_INSTRUCTION'})}{' '}
          <span
            className='gori-signature-tutorial__inline-link text-decoration-underline cursor-pointer'
            onClick={() =>
              navigate(ROUTES.GORI_SIGNATURE.METHOD_SELECT, {
                state: {hash: hash},
              })
            }
          >
            {intl.formatMessage({id: 'GORI_SIGNATURE_TRY_DIFFERENT_METHOD'})}
          </span>
        </p>
      </div>
    </>
  )
}
NavigationControls.displayName = 'NavigationControls'

export function ManualCaptureButton({onManualCapture, isCapturing}: NavigationControlsProps) {
  const intl = useIntl()

  return (
    <div className='text-center mt-4'>
      <button
        type='button'
        className='btn btn-advanced-primary btn-lg'
        onClick={onManualCapture}
        disabled={isCapturing}
        aria-label={intl.formatMessage({id: 'GORI_SIGNATURE_MANUAL_CAPTURE'})}
        aria-busy={isCapturing}
      >
        {intl.formatMessage({id: 'GORI_SIGNATURE_MANUAL_CAPTURE'})}
      </button>
    </div>
  )
}
ManualCaptureButton.displayName = 'ManualCaptureButton'
